export default __webpack_public_path__ + "static/media/icon_user-2.748fd81c.svg";